// @ts-nocheck
import { setCookie } from "@insite/client-framework/Common/Cookies";
import { addToChainBefore, ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import { rawRequest } from "@insite/client-framework/Services/ApiService";
import { Session, UpdateSessionApiParameter } from "@insite/client-framework/Services/SessionService";
import { getLanguages, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, ReloadPage } from "@insite/client-framework/Store/Context/Handlers/SetLanguage";

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

type HandlerType = ApiHandlerDiscreteParameter<{ languageId: string }, UpdateSessionApiParameter, Session>;

export const SaveToAccountIfAuthenticated: HandlerType = async props => {
    const state = props.getState();
    const { session } = state.context;
    if (!session.isAuthenticated || !session.userProfileId) {
        return;
    }

    const language = getLanguages(state)?.find(o => o.id === props.parameter.languageId);
    if (!language) {
        return;
    }

    await rawRequest(
        `/api/v1/users/${session.userProfileId}/preferred-language`,
        "PATCH",
        { "Content-Type": "application/json" },
        JSON.stringify(language.languageCode),
    );
};

export const SetPersistentLanguageCookie: HandlerType = props => {
    const settings = getSettingsCollection(props.getState());
    const expires = settings?.accountSettings.daysToRetainUser || 365;
    setCookie("CurrentLanguageId", props.parameter.languageId, { path: "/", expires });
};

addToChainBefore(chain, ReloadPage, SaveToAccountIfAuthenticated);
addToChainBefore(chain, ReloadPage, SetPersistentLanguageCookie);
